import { SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { Styles } from "./successAndErrorMessage.style";
import { useEffect, useState } from "react";
import useIsMounted from "ismounted";
import { notifyMessage } from "../../common/notifyMessage";

interface PropsInterface {
  notificationMessage?: string;
  styles?: React.CSSProperties;
  successClassName?: string;
  failureClassName?: string;
  warningClassName?: string;
  closeButtonPresent?: boolean;
  onDismiss?: (type: string) => void;
}

const SuccessAndErrorMessage = (props: PropsInterface) => {
  const { notificationMessage, styles, successClassName, failureClassName, warningClassName } =
    props;
  const [onClose, setOnClose] = useState<boolean>();
  const isMounted = useIsMounted();
  const handleClose = () => {
    setOnClose(false);
  };
  useEffect(() => {
    setOnClose(true);
  }, [onClose]);

  useEffect(() => {
    if (isMounted) {
      if (!notificationMessage) {
        notifyMessage(successClassName || "successMessage", 0);
        notifyMessage(failureClassName || "errorMessage", 0);
        notifyMessage(warningClassName || "warningMessage", 0);
      }
    }
  }, [notificationMessage]);

  return (
    <>
      {onClose && (
        <div
          id={successClassName ? successClassName : "successMessage"}
          style={{ ...Styles.messageBar, ...styles }}
        >
          <div style={Styles.messageStack("success") as any}>
            <SkyMessageBar
              intent="success"
              className={successClassName ? successClassName : "successMessage"}
              message={
                <div
                  className={`flex flex-row gap-2.5 ${successClassName ? successClassName : "successMessage"}`}
                >
                  <span style={Styles.notificationMessage}>{notificationMessage}</span>
                </div>
              }
              onDismiss={handleClose}
            />
          </div>
        </div>
      )}
      {onClose && (
        <div
          id={failureClassName ? failureClassName : "errorMessage"}
          style={{ ...Styles.messageBar, ...styles }}
        >
          <div style={Styles.messageStack("error") as any}>
            <SkyMessageBar
              intent="error"
              className={failureClassName ? failureClassName : "errorMessage"}
              message={
                <div
                  className={`flex flex-row gap-2.5 ${failureClassName ? failureClassName : "errorMessage"}`}
                >
                  <span style={Styles.notificationMessage}>{notificationMessage}</span>
                </div>
              }
              onDismiss={handleClose}
            />
          </div>
        </div>
      )}

      {onClose && (
        <div
          id={warningClassName ? warningClassName : "warningMessage"}
          style={{ ...Styles.messageBar, ...styles }}
        >
          <div style={Styles.messageStack("warning") as any}>
            <SkyMessageBar
              intent="error"
              className={warningClassName ? warningClassName : "warningMessage"}
              message={
                <div
                  className={`flex flex-row gap-2.5 ${warningClassName ? warningClassName : "warningMessage"}`}
                >
                  <span style={Styles.notificationMessage}>{notificationMessage}</span>
                </div>
              }
              onDismiss={handleClose}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessAndErrorMessage;
